import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetDescriptionParams } from '../types/actionParams';

export class SetFlowDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setFlowDescription', {
      id,
      description
    });
  }
}
